import { Swiper } from 'swiper';
import { Autoplay, Navigation, Pagination, A11y } from 'swiper/modules';

import 'swiper/css';

const sectionTestimonials = document.querySelectorAll('section.testimonials');

document.addEventListener('DOMContentLoaded', () => {
	sectionTestimonials.forEach((section) => {
		if(section.querySelector('.testimonials-wrapper')) {
			const sectionId = section.getAttribute('id');
			const swiperId = `#${sectionId} .swiper`;
			const navigation = section.querySelector('.swiper').dataset.navigation;

			const testimonialsSlider = new Swiper(swiperId, {
				modules: [ Autoplay, Navigation, Pagination, A11y ],
				speed: 700,
				autoplay: {
					delay: 5000,
					pauseOnMouseEnter: true,
				},
				slidesPerView: 1,
				spaceBetween: 32,
				autoHeight: true,
				pagination: {
					el: `#${sectionId} .swiper-pagination`,
					clickable: true,
					dynamicBullets: true,
					dynamicMainBullets: 5,
					enabled: navigation ? navigation : false,
				},
			});
		}
	});
});
